import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Grid, Button } from "@mui/material";

import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import DoneIcon from "@mui/icons-material/Done";

import Zoom from "react-medium-image-zoom";
// import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
// import EmailIcon from "@mui/icons-material/Email";
import AddIcon from "@mui/icons-material/Add";

// Import For According
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// End

// For Modal
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
// End

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
function AddResidentNewTab() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // For According
  const [expanded, setExpanded] = React.useState(false);

  const handleChange2 = (panel) => (event2, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  // End

  // For Modal
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState("paper");

  const handleClickOpen = (scrollType) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);
  // End

  return (
    <>
      <Box sx={{ width: "100%" }} style={{ marginTop: "50px" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label="Owners Details" {...a11yProps(0)} />
            <Tab label="Tenents Details" {...a11yProps(1)} />
            {/* <Tab label="Item Three" {...a11yProps(2)} /> */}
          </Tabs>
        </Box>
        <TabPanel value={value} index={0} className="tabPanelTopSpace">
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <div className="tabLeftDiv">
                <div className="uploadImDiv">
                  <div className="uploadIm">
                    <img src="https://i0.wp.com/mytechoffer.com/wp-content/uploads/2022/05/09b1daaf2958e78a20be454394024869-asma.jpeg?resize=700%2C769&ssl=1" alt="altimg"/>
                  </div>
                  <div className="uploadInpu">
                    <FileUploadIcon />
                    <span>Upload Profile Photo</span>
                    <input type="file" />
                  </div>
                </div>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <label className="tabsLabel">First Name</label>
                    <input className="inputSt" placeholder="First Name" />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <label className="tabsLabel">Last Name</label>
                    <input className="inputSt" placeholder="Last Name" />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <label className="tabsLabel">Phone Number</label>
                    <input className="inputSt" placeholder="Phone Number" />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <label className="tabsLabel">Email Id</label>
                    <input className="inputSt" placeholder="Email Id" />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <label className="tabsLabel">Age</label>
                    <input className="inputSt" placeholder="Age" />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <label className="tabsLabel">Family Member Count</label>
                    <input
                      className="inputSt"
                      placeholder="Family Member Count"
                    />
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <label className="tabsLabel">
                      How many Apartment do you own?
                    </label>
                    <input
                      className="inputSt"
                      placeholder="How many Apartment do you own?"
                    />
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="tabRightDiv">
                <h4 className="documeUpload documeUploadIcon">
                  Documents Upload
                  <Button className="forUploadOnly">
                    <FileUploadIcon />
                    <input
                      type="file"
                      style={{ opacity: "0", position: "absolute", left: "0" }}
                    />
                  </Button>
                </h4>

                <div className="doqumentDiv1">
                  <span>
                    Aadhar Card <DoneIcon />
                  </span>
                  <Button className="documRemove">
                    <DeleteForeverIcon />
                  </Button>
                </div>
                <div className="doqumentDiv1">
                  <span>
                    Pan Card <DoneIcon />
                  </span>
                  <Button className="documRemove">
                    <DeleteForeverIcon />
                  </Button>
                </div>
                <div className="doqumentDiv1">
                  <span>
                    Driving Licence <DoneIcon />
                  </span>
                  <Button className="documRemove">
                    <DeleteForeverIcon />
                  </Button>
                </div>
              </div>
            </Grid>

            <Grid item xs={12} md={12}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={12}>
                  <h4 className="addApHeading">Add Apartment</h4>
                </Grid>
                <Grid item xs={12} md={4}>
                  <div className="tenentLeftContentMain">
                    <ul>
                      <li className="addedApartCont">
                        <h4>John Doe</h4>
                        <span>Wing A - 503</span>
                      </li>
                      <li className="addedApartCont activAddedApartCont">
                        <h4>Apartment 2</h4>
                      </li>
                    </ul>
                  </div>
                </Grid>
                <Grid item xs={12} md={8}>
                  <div className="newAddResiMain">
                    <div className="tabLeftDiv">
                      {/* <div className="uploadImDiv">
                              <div className="uploadIm">
                                <img src="https://i0.wp.com/mytechoffer.com/wp-content/uploads/2022/05/09b1daaf2958e78a20be454394024869-asma.jpeg?resize=700%2C769&ssl=1" />
                              </div>
                              <div className="uploadInpu">
                                <FileUploadIcon />
                                <span>Upload Profile Photo</span>
                                <input type="file" />
                              </div>
                            </div> */}
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                          <select className="inputSt">
                            <option>Building</option>
                            <option>Building 1</option>
                            <option>Building 2</option>
                            <option>Building 3</option>
                          </select>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <select className="inputSt">
                            <option>Wing</option>
                            <option>Wing 1</option>
                            <option>Wing 2</option>
                            <option>Wing 3</option>
                          </select>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <input
                            className="inputSt"
                            placeholder="Assigned Parking Slot"
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <select className="inputSt">
                            <option>Select Apartment No.</option>
                            <option>Apartment no. here</option>
                          </select>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <select className="inputSt">
                            <option>Resident Type</option>
                            <option>Resident Type 1</option>
                            <option>Resident Type 2</option>
                          </select>
                        </Grid>
                        <Grid item xs={12} md={12}>
                          <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                              <Button className="addApBt">Add Apartment</Button>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Button className="addAprtmentBt">
                                <AddIcon /> Add Apartment
                              </Button>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} md={12}>
                  <div className="addOwnerTopLine">
                    <Button className="addBt" onClick={handleClickOpen("body")}>
                      Add Apartment Owner
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} md={12}>
              <div className="acordingViewMain">
                <Accordion
                  expanded={expanded === "panel2"}
                  onChange={handleChange2("panel2")}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2bh-content"
                    id="panel2bh-header"
                  >
                    <Typography>Add Family Members kkk</Typography>
                  </AccordionSummary>

                  <AccordionDetails>
                    <div className="acordingCont">
                      <Grid container spacing={3} style={{ marginTop: "10px" }}>
                        <Grid item xs={12} md={4}>
                          <div className="tenentLeftContentMain">
                            <ul>
                              <li>
                                <div className="tenantDProfile">
                                  <Zoom>
                                    <img src="https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8bWFsZSUyMHByb2ZpbGV8ZW58MHx8MHx8&w=1000&q=80" alt="altimg"/>
                                  </Zoom>
                                </div>
                                <h4>Sanjay Sharma</h4>
                                <span>38 Year</span>
                              </li>
                              <li>
                                <div className="tenantDProfile">
                                  <Zoom>
                                    <img src="https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8bWFsZSUyMHByb2ZpbGV8ZW58MHx8MHx8&w=1000&q=80" alt="altimg"/>
                                  </Zoom>
                                </div>
                                <h4>Rajshree Sharma</h4>
                                <span>33 Year</span>
                              </li>
                              <li className="addedApartCont activAddedApartCont">
                                <h4>Member 3</h4>
                              </li>
                            </ul>
                          </div>
                        </Grid>
                        <Grid item xs={12} md={8}>
                          <div className="newAddResiMain">
                            <div className="tabLeftDiv">
                              <div className="uploadImDiv">
                                <div className="uploadIm">
                                  <img src="https://i0.wp.com/mytechoffer.com/wp-content/uploads/2022/05/09b1daaf2958e78a20be454394024869-asma.jpeg?resize=700%2C769&ssl=1" alt="altimg"/>
                                </div>
                                <div className="uploadInpu">
                                  <FileUploadIcon />
                                  <span>Upload Profile Photo</span>
                                  <input type="file" />
                                </div>
                              </div>
                              <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                  <input
                                    className="inputSt"
                                    placeholder="First Name"
                                  />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <input
                                    className="inputSt"
                                    placeholder="Last Name"
                                  />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <input
                                    className="inputSt"
                                    placeholder="Phone Number"
                                  />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <input
                                    className="inputSt"
                                    placeholder="Email Id"
                                  />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <input
                                    className="inputSt"
                                    placeholder="Age"
                                  />
                                </Grid>

                                <Grid item xs={12} md={12}>
                                  <Grid container spacing={3}>
                                    <Grid item xs={12} md={6}>
                                      <Button className="addApBt">
                                        Add Member
                                      </Button>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                      <Button className="addAprtmentBt">
                                        <AddIcon /> Add New Member
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </div>
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                  </AccordionDetails>
                </Accordion>

                <Accordion
                  expanded={expanded === "panel3"}
                  onChange={handleChange2("panel3")}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2bh-content"
                    id="panel2bh-header"
                  >
                    <Typography>Add Vehicles</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div
                      className="acordingCont"
                      style={{ margin: "10px 0 20px" }}
                    >
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                          <div className="tenentLeftContentMain">
                            <ul>
                              <li className="addedApartCont">
                                <h4>
                                  2 Wheeler &nbsp;
                                  <em className="vehicleNoTx">MH 12 YZ 8640</em>
                                </h4>
                                <span>Reg No. 234560985347</span>
                              </li>
                              <li className="addedApartCont activAddedApartCont">
                                <h4>Vehicle 2</h4>
                              </li>
                            </ul>
                          </div>
                        </Grid>
                        <Grid item xs={12} md={8}>
                          <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                              <select className="inputSt inputStForAdVehicle">
                                <option>Vehicle type</option>
                                <option>Vehicle type 2</option>
                                <option>Vehicle type 3</option>
                              </select>

                              <input
                                type="text"
                                className="inputSt inputStForAdVehicle"
                                placeholder="Owner Name"
                              />

                              <input
                                type="text"
                                className="inputSt inputStForAdVehicle"
                                placeholder="Registration Number"
                              />

                              <input
                                type="text"
                                className="inputSt inputStForAdVehicle"
                                placeholder="Vehicle Number"
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <div className="tabRightDiv">
                                <h4 className="documeUpload documeUploadIcon">
                                  Documents Upload
                                  <Button className="forUploadOnly">
                                    <FileUploadIcon />
                                    <input type="file" />
                                  </Button>
                                </h4>

                                <div className="doqumentDiv1">
                                  <span>
                                    Aadhar Card <DoneIcon />
                                  </span>
                                  <Button className="documRemove">
                                    <DeleteForeverIcon />
                                  </Button>
                                </div>
                                <div className="doqumentDiv1">
                                  <span>
                                    Pan Card <DoneIcon />
                                  </span>
                                  <Button className="documRemove">
                                    <DeleteForeverIcon />
                                  </Button>
                                </div>
                                <div className="doqumentDiv1">
                                  <span>
                                    Driving Licence <DoneIcon />
                                  </span>
                                  <Button className="documRemove">
                                    <DeleteForeverIcon />
                                  </Button>
                                </div>
                              </div>
                            </Grid>

                            <Grid item xs={12} md={12}>
                              <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                  <Button className="addApBt">
                                    Add Vehicle
                                  </Button>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <Button className="addAprtmentBt">
                                    <AddIcon /> Add New Vehicle
                                  </Button>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
            </Grid>
          </Grid>
        </TabPanel>

        <TabPanel value={value} index={1} className="tabPanelTopSpace">
          <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
              <div className="tenentTabMain">
                <div className="tenentTabInOut">
                  <h5 className="tenetTbHeading">Tenent 1</h5>
                  <div className="tenentTabInDiv">
                    <div className="tenentTabInPro">
                      <Zoom>
                        <img src="https://d2qp0siotla746.cloudfront.net/img/use-cases/profile-picture/template_3.jpg" alt="altimg"/>
                      </Zoom>
                    </div>
                    <h4>Sanjay Sharma</h4>
                    <span>38 Year</span>
                  </div>
                </div>

                <div className="tenentTabInOut">
                  <h5 className="tenetTbHeading">Tenent 2</h5>
                  <div className="tenentTabInDiv activeTabOfTenent">
                    <div className="tenentTabInPro">
                      <Zoom>
                        <img src="https://i0.wp.com/mytechoffer.com/wp-content/uploads/2022/05/09b1daaf2958e78a20be454394024869-asma.jpeg?resize=700%2C769&ssl=1" alt="altimg"/>
                      </Zoom>
                    </div>
                    <h4>Full name</h4>
                    <span>00 Year</span>
                  </div>
                </div>
              </div>
            </Grid>

            <Grid item xs={12} md={6}>
              <div className="tabLeftDiv">
                <div className="uploadImDiv">
                  <div className="uploadIm">
                    <img src="https://i0.wp.com/mytechoffer.com/wp-content/uploads/2022/05/09b1daaf2958e78a20be454394024869-asma.jpeg?resize=700%2C769&ssl=1" alt="altimg"/>
                  </div>
                  <div className="uploadInpu">
                    <FileUploadIcon />
                    <span>Upload Profile Photo</span>
                    <input type="file" />
                  </div>
                </div>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <input className="inputSt" placeholder="First Name" />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <input className="inputSt" placeholder="Last Name" />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <input className="inputSt" placeholder="Phone Number" />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <input className="inputSt" placeholder="Email Id" />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <input className="inputSt" placeholder="Age" />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <input
                      className="inputSt"
                      placeholder="Family Member Count"
                    />
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="tabRightDiv">
                <h4 className="documeUpload documeUploadIcon">
                  Documents Upload
                  <Button className="forUploadOnly">
                    <FileUploadIcon />
                    <input
                      type="file"
                      style={{ opacity: "0", position: "absolute", left: "0" }}
                    />
                  </Button>
                </h4>

                <div className="doqumentDiv1">
                  <span>
                    Aadhar Card <DoneIcon />
                  </span>
                  <Button className="documRemove">
                    <DeleteForeverIcon />
                  </Button>
                </div>
                <div className="doqumentDiv1">
                  <span>
                    Pan Card <DoneIcon />
                  </span>
                  <Button className="documRemove">
                    <DeleteForeverIcon />
                  </Button>
                </div>
                <div className="doqumentDiv1">
                  <span>
                    Driving Licence <DoneIcon />
                  </span>
                  <Button className="documRemove">
                    <DeleteForeverIcon />
                  </Button>
                </div>
              </div>
            </Grid>

            <Grid item xs={12} md={12}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={12}>
                  <h4 className="addApHeading">Add Flats</h4>
                </Grid>
                <Grid item xs={12} md={4}>
                  <select className="inputSt">
                    <option>Building</option>
                    <option>Building 1</option>
                    <option>Building 2</option>
                    <option>Building 3</option>
                  </select>
                </Grid>
                <Grid item xs={12} md={4}>
                  <select className="inputSt">
                    <option>Wing</option>
                    <option>Wing 1</option>
                    <option>Wing 2</option>
                    <option>Wing 3</option>
                  </select>
                </Grid>
                <Grid item xs={12} md={4}>
                  <input
                    className="inputSt"
                    placeholder="Assigned Parking Slot"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <select className="inputSt">
                    <option>Select Apartment No.</option>
                    <option>Apartment no. here</option>
                  </select>
                </Grid>
                <Grid item xs={12} md={4}>
                  <select className="inputSt">
                    <option>Resident Type</option>
                    <option>Resident Type 1</option>
                    <option>Resident Type 2</option>
                  </select>
                </Grid>

                <Grid item xs={12} md={12} style={{ textAlign: "center" }}>
                  <Button className="addBt">Add Tenent</Button>
                </Grid>

                {/* <Grid item xs={12} md={12}>
                  <div className="addOwnerTopLine">
                    <Button className="addBt" onClick={handleClickOpen("body")}>
                      Add Apartment Owner
                    </Button>
                  </div>
                </Grid> */}
              </Grid>
            </Grid>

            <Grid item xs={12} md={12}>
              <div className="acordingViewMain">
                <Accordion
                  expanded={expanded === "panel2"}
                  onChange={handleChange2("panel2")}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2bh-content"
                    id="panel2bh-header"
                  >
                    <Typography>Add Family Members kkkkkk</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className="acordingCont">
                      <Grid container spacing={3} style={{ marginTop: "10px" }}>
                        <Grid item xs={12} md={4}>
                          <div className="tenentLeftContentMain">
                            <ul>
                              <li>
                                <div className="tenantDProfile">
                                  <Zoom>
                                    <img src="https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8bWFsZSUyMHByb2ZpbGV8ZW58MHx8MHx8&w=1000&q=80" alt="altimg"/>
                                  </Zoom>
                                </div>
                                <h4>Sanjay Sharma</h4>
                                <span>38 Year</span>
                              </li>
                              <li>
                                <div className="tenantDProfile">
                                  <Zoom>
                                    <img src="https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8bWFsZSUyMHByb2ZpbGV8ZW58MHx8MHx8&w=1000&q=80" alt="altimg"/>
                                  </Zoom>
                                </div>
                                <h4>Rajshree Sharma</h4>
                                <span>33 Year</span>
                              </li>
                              <li className="addedApartCont activAddedApartCont">
                                <h4>Member 3</h4>
                              </li>
                            </ul>
                          </div>
                        </Grid>
                        <Grid item xs={12} md={8}>
                          <div className="newAddResiMain">
                            <div className="tabLeftDiv">
                              <div className="uploadImDiv">
                                <div className="uploadIm">
                                  <img src="https://i0.wp.com/mytechoffer.com/wp-content/uploads/2022/05/09b1daaf2958e78a20be454394024869-asma.jpeg?resize=700%2C769&ssl=1" alt="altimg"/>
                                </div>
                                <div className="uploadInpu">
                                  <FileUploadIcon />
                                  <span>Upload Profile Photo</span>
                                  <input type="file" />
                                </div>
                              </div>
                              <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                  <input
                                    className="inputSt"
                                    placeholder="First Name"
                                  />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <input
                                    className="inputSt"
                                    placeholder="Last Name"
                                  />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <input
                                    className="inputSt"
                                    placeholder="Phone Number"
                                  />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <input
                                    className="inputSt"
                                    placeholder="Email Id"
                                  />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <input
                                    className="inputSt"
                                    placeholder="Age"
                                  />
                                </Grid>

                                <Grid item xs={12} md={12}>
                                  <Grid container spacing={3}>
                                    <Grid item xs={12} md={6}>
                                      <Button className="addApBt">
                                        Add Member
                                      </Button>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                      <Button className="addAprtmentBt">
                                        <AddIcon /> Add New Member
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </div>
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                  </AccordionDetails>
                </Accordion>

                <Accordion
                  expanded={expanded === "panel3"}
                  onChange={handleChange2("panel3")}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2bh-content"
                    id="panel2bh-header"
                  >
                    <Typography>Add Vehicles</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div
                      className="acordingCont"
                      style={{ margin: "10px 0 20px" }}
                    >
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                          <div className="tenentLeftContentMain">
                            <ul>
                              <li className="addedApartCont">
                                <h4>
                                  2 Wheeler &nbsp;
                                  <em className="vehicleNoTx">MH 12 YZ 8640</em>
                                </h4>
                                <span>Reg No. 234560985347</span>
                              </li>
                              <li className="addedApartCont activAddedApartCont">
                                <h4>Vehicle 2</h4>
                              </li>
                            </ul>
                          </div>
                        </Grid>
                        <Grid item xs={12} md={8}>
                          <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                              <select className="inputSt inputStForAdVehicle">
                                <option>Vehicle type</option>
                                <option>Vehicle type 2</option>
                                <option>Vehicle type 3</option>
                              </select>

                              <input
                                type="text"
                                className="inputSt inputStForAdVehicle"
                                placeholder="Owner Name"
                              />

                              <input
                                type="text"
                                className="inputSt inputStForAdVehicle"
                                placeholder="Registration Number"
                              />

                              <input
                                type="text"
                                className="inputSt inputStForAdVehicle"
                                placeholder="Vehicle Number"
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <div className="tabRightDiv">
                                <h4 className="documeUpload documeUploadIcon">
                                  Documents Upload
                                  <Button className="forUploadOnly">
                                    <FileUploadIcon />
                                    <input type="file" />
                                  </Button>
                                </h4>

                                <div className="doqumentDiv1">
                                  <span>
                                    Aadhar Card <DoneIcon />
                                  </span>
                                  <Button className="documRemove">
                                    <DeleteForeverIcon />
                                  </Button>
                                </div>
                                <div className="doqumentDiv1">
                                  <span>
                                    Pan Card <DoneIcon />
                                  </span>
                                  <Button className="documRemove">
                                    <DeleteForeverIcon />
                                  </Button>
                                </div>
                                <div className="doqumentDiv1">
                                  <span>
                                    Driving Licence <DoneIcon />
                                  </span>
                                  <Button className="documRemove">
                                    <DeleteForeverIcon />
                                  </Button>
                                </div>
                              </div>
                            </Grid>

                            <Grid item xs={12} md={12}>
                              <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                  <Button className="addApBt">
                                    Add Vehicle
                                  </Button>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <Button className="addAprtmentBt">
                                    <AddIcon /> Add New Vehicle
                                  </Button>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
            </Grid>

            {/* <Grid item xs={12} md={12}>
            <Button className="addBt">Add Apartment Owner</Button>
          </Grid> */}
          </Grid>
        </TabPanel>
      </Box>

      <div className="modalMain">
        {/* <Button onClick={handleClickOpen("paper")}>scroll=paper</Button>
      <Button onClick={handleClickOpen("body")}>scroll=body</Button> */}
        <Dialog
          open={open}
          // onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Success !</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <Grid container spacing={3}>
                <Grid item xs={12} md={12}>
                  <div className="succesMain">
                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" alt="altimg"/>
                    <h4>Success !</h4>
                    <p>
                      Resident added successfully in <br /> database
                    </p>
                  </div>
                </Grid>
              </Grid>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
}

export default AddResidentNewTab;
